import { esES as coreEsES } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';

const theme = createTheme(
  {
    palette: {
      mode: 'light',
      primary: {
        main: '#7025c6',
      },
      secondary: {
        main: '#f50057',
      },
      text: {
        primary: '#332D3A',
        secondary: '#341E57',
        disabled: '#AFACB3',
      },
      divider: '#F0EEF2',
      grey: {
        50: '#F8F9FC',
        100: '#F0EEF2',
        200: '#E8EAF1',
        300: '#E4E1E7',
        400: '#D8DAE5',
      },
      action: {
        hover: '#E4E1E7',
        disabledBackground: '#F8F9FC',
      },
    },
    spacing: 8,
    typography: {
      fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
      h4: {
        fontWeight: 600,
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
  },

  coreEsES
);

export default theme;
